import { render, staticRenderFns } from "./EditMagazzino.vue?vue&type=template&id=ec5bf30a&"
import script from "./EditMagazzino.vue?vue&type=script&lang=js&"
export * from "./EditMagazzino.vue?vue&type=script&lang=js&"
import style0 from "./EditMagazzino.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports